
import React, { Component, PropTypes } from 'react';

class Html extends Component {
  static propTypes = {
    markup: PropTypes.string.isRequired,
  }
  render() {
    const { markup } = this.props;
    return (
      <div dangerouslySetInnerHTML={{ __html: markup }} />
    );
  }
}

export default Html;



/** WEBPACK FOOTER **
 ** ./src/components/Html/index.js
 **/